import Colors from "../../utils/Colors";
import MindElementAlignmentType from "../../viewmodel/datatype/MindElementAlignmentType";
import MindElementShapeType from "../../viewmodel/datatype/MindElementShapeType";
import LineMindTypeNode from "../../viewmodel/mindelementdata/LineMindTypeNode";
import TextContent from "../../viewmodel/mindelementdata/mindcontent/TextContent";
import MindElementData from "../../viewmodel/mindelementdata/MindElementData";

class MindmapSDKSubjectData {

    constructor() {
        this.x = -1;
        this.y = -1;
        this.backgroundColor = 0xF1F1F1;
        this.backgroundColorAlpha = 1.0;
        this.borderColor = 0xF1F1F1;
        this.borderColorAlpha = 1.0;
        this.borderWidth = 0;
        this.mindElementShape = MindElementShapeType.Corner;    
        this.alignmentType = MindElementAlignmentType.LEFT;
        this.text = "";
        this.textColor = 0x333333;
        this.textFontSize = 18;
        this.styleCells = [] //MindmapSDKTextStyleCell
    }


    toMindElementData() {
        let data = new MindElementData();
        data.x = this.x;
        data.y = this.y;
        data.backgroundColor = this.backgroundColor <= 1 ? 0x000002 : this.backgroundColor;
        data.backgroundColorAlpha = this.backgroundColorAlpha;
        data.borderColor = this.borderColor <= 1 ? 0x000002 : this.borderColor;
        data.borderColorAlpha = this.borderColorAlpha;
        data.borderWidth = this.borderWidth;
        data.mindElementShape = this.mindElementShape;    
        data.alignmentType = this.alignmentType;
        data.textContent = new TextContent(this.text)
        data.textContent.textColor = this.textColor <= 1 ? 0x000002 : this.textColor;
        data.textContent.textFontSize = this.textFontSize;
        if (this.styleCells != null && this.styleCells.length > 0) {
            let textStyleCells = [];
            for (let index = 0; index < this.styleCells.length; index++) {
                const cell = this.styleCells[index];
                textStyleCells.push(cell.toTextStyleCell())
            }
            data.textContent.styleCells = textStyleCells;
        }
        return data;
    }
}



export default MindmapSDKSubjectData
